module.exports = __webpack_public_path__ + "img/plateau_nenuphar-mobile.9d884d3c.webp";